const state = {
    isLoading: true,
    baseApiUrl: null,
    components: null,
    incident: null,
    incidents: null,
    component: null,
    latestIncidents: null,
    status: null,
    reportData: null
}

export var getState = function () {
    return JSON.parse(JSON.stringify(state))
}



// WEBPACK FOOTER //
// ./src/store/state.js